import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { Summary } from './Summary.js';

const SummaryContainer = ({ readOnly , hasSubscription , donationAmount  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Summary, {
        summaryLabel: getLabel('cart.discount.summary'),
        readOnly: readOnly,
        hasSubscription: hasSubscription,
        donationAmount: donationAmount
    });
};

export { SummaryContainer };
//# sourceMappingURL=SummaryContainer.js.map
